<label [attr.for]="'Custom CSS'">{{ ('Custom CSS' | translate) + ':' }}</label>
<input id="styleCss" size="100" type="text" [(ngModel)]="styleCss">
<button (click)="onClick()">{{'Apply' | translate}}</button>